/* eslint-disable max-len */
/* eslint-disable no-plusplus */
// libraries
import React from 'react';
import {
    Button,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    TextField,
} from '@material-ui/core';
import { CheckCircle, NavigateBefore, Send } from '@material-ui/icons';
import { v4 as uuidv4 } from 'uuid';

// js
import defaultSound from '../../../assets/images/defaultSound.png';
import defaultPhoto from '../../../assets/images/default.png';
import { allMenuItems } from './taskConstants';
import {
    ContainerAdjustIconEdit,
    ContainerOptions,
    InputNullSelectedPhoto,
    Logo,
    TitleOption,
} from '../modulesStyles';

// interfaces
import type { DataModuleInterface, SelectedWordForTranslationInterface } from '../modulesInterfaces';
import uploads from '../../../services/uploads';
import tasks from '../../../services/tasks';

const TaskSelectedWordForTranslation = (
    setIdModal: any,
    initialDataTaskSelectedWordForTranslation: SelectedWordForTranslationInterface,
    taskSelectedWordForTranslation: SelectedWordForTranslationInterface,
    setTaskSelectedWordForTranslation: any,
    dataModule: DataModuleInterface,
) => {
    // constants
    const token: any = String(localStorage.getItem('token') || '');
    const adjustMarginBottom = { marginBottom: 10 };
    const adjustButtonLogo = { marginBottom: 25, width: 200 };
    const adjustWidthSelectedActivities = { width: 200 };
    const marginDefault = { marginRight: 10 };

    // methods
    const BackScreenModal = () => {
        setIdModal(1);
        setTaskSelectedWordForTranslation(initialDataTaskSelectedWordForTranslation);
    };

    const CreateTask = async () => {
        const formatOptions = taskSelectedWordForTranslation?.options?.map((e: any) => {
            const option = e;
            delete option.idWrapperTask;
            return option;
        });
        const formatTask: any = {
            ...taskSelectedWordForTranslation,
            options: formatOptions,
            idTask: taskSelectedWordForTranslation.id,
            idModule: dataModule?.id,
        };
        delete formatTask?.id;
        if (formatTask?.idTask) {
            const editTask: any = await tasks.EditTask(formatTask, token);
            if (editTask) {
                BackScreenModal();
            }
        } else {
            delete formatTask?.idTask;
            const createTask: any = await tasks.CreateTask(formatTask, token);
            if (createTask) {
                BackScreenModal();
            }
        }
    };

    const onChangeTitle = (txt: any) => {
        if (txt.target.value.length <= 200) {
            const newDataTask = { ...taskSelectedWordForTranslation, title: txt.target.value };
            setTaskSelectedWordForTranslation(newDataTask);
        }
    };

    const onChangeSubtitle = (txt: any) => {
        if (txt.target.value.length <= 200) {
            const newDataTask = { ...taskSelectedWordForTranslation, subtitle: txt.target.value };
            setTaskSelectedWordForTranslation(newDataTask);
        }
    };

    const onChangeQuestion = (txt: any) => {
        if (txt.target.value.length <= 200) {
            const newDataTask = { ...taskSelectedWordForTranslation, question: txt.target.value };
            setTaskSelectedWordForTranslation(newDataTask);
        }
    };

    const onChangeOptionSkipTask = (txt: any) => {
        const newDataTask = { ...taskSelectedWordForTranslation, skip: txt.target.value };
        setTaskSelectedWordForTranslation(newDataTask);
    };

    const validationDisabled = () => {
        let valueObject = true;
        if (taskSelectedWordForTranslation?.id) {
            const ValidationLength = Object.values(taskSelectedWordForTranslation).filter((v) => v !== '').length !== 11;
            const ValidationOptionsLength = taskSelectedWordForTranslation?.options.filter((v: any) => v.option).length === taskSelectedWordForTranslation?.options?.length;
            if (!ValidationLength && ValidationOptionsLength) {
                valueObject = false;
            }
        } else if (!taskSelectedWordForTranslation?.id) {
            const ValidationLength = Object.values(taskSelectedWordForTranslation).filter((v) => v !== '').length !== 10;
            if (!ValidationLength) {
                valueObject = false;
            }
        }
        return valueObject;
    };

    const validationBackground = () => {
        const valueObject = Object.values(taskSelectedWordForTranslation).filter((v) => v !== '');
        const ValidationOptionsLength = taskSelectedWordForTranslation?.options.filter((v: any) => v.option).length === taskSelectedWordForTranslation?.options?.length;
        if ((taskSelectedWordForTranslation?.id ? valueObject.length === 11 : valueObject.length === 10) && ValidationOptionsLength) {
            return 'primary';
        }

        return 'inherit';
    };

    const onChangeTarget = (txt: any) => {
        const allOptions = [];
        for (let i = 0; i < Number(txt.target.value); i++) {
            const objOrigin = {
                option: '',
                id: uuidv4(),
            };
            allOptions.push(objOrigin);
            if (allOptions.length === Number(txt.target.value)) {
                const orderNewDataOption = allOptions.sort((a, b) => {
                    if (a.id < b.id) return -1;
                    if (a.id > b.id) return 1;
                    return 0;
                });
                const newDataTask = {
                    ...taskSelectedWordForTranslation,
                    target: Number(txt.target.value),
                    options: orderNewDataOption,
                    // correct: orderNewDataOption.filter((v: any) => !v.optionEnglish || !v.optionPortuguese).length > 0 ? '' : taskSelectedWordForTranslation?.correct,
                };
                setTaskSelectedWordForTranslation(newDataTask);
            }
        }
    };

    const onChangeOptionCorrect = (txt: any) => {
        const newDataTask = { ...taskSelectedWordForTranslation, correct: txt.target.value };
        setTaskSelectedWordForTranslation(newDataTask);
    };

    // renders
    const RenderAllOptionsCorrect = () => {
        const AllOptionsEnglish = [] as any;
        const test = taskSelectedWordForTranslation.options.map(
            (v: any) => AllOptionsEnglish.push(v.option),
        );
        if (AllOptionsEnglish.length === test.length) {
            return AllOptionsEnglish.map((option: any) => (
                <MenuItem value={option}>{option}</MenuItem>
            ));
        }

        return null;
    };

    const RenderSelectedCorrectOptions = (skipTask: boolean) => {
        const options = taskSelectedWordForTranslation.options.filter((v: any) => v.option !== '').length;
        const allOptions = options === taskSelectedWordForTranslation.target;

        if (options > 0 && allOptions && !skipTask) {
            const SelectedAudio = async (event: any) => {
                if (event.target.files.length) {
                    const newDataFiles = {
                        eventFile: event.target.files[0],
                        eventName: event.target.files[0].name,
                        file: URL.createObjectURL(event.target.files[0]),
                    };
                    const upload: any = await uploads.UploadFile(newDataFiles.eventFile);
                    if (upload) {
                        setTaskSelectedWordForTranslation({ ...taskSelectedWordForTranslation, file: upload.result });
                        // eslint-disable-next-line no-param-reassign
                        event.target.value = null;
                    }
                }
            };

            const SelectedPhoto = async (event: any) => {
                if (event.target.files.length) {
                    const newDataFiles = {
                        eventFile: event.target.files[0],
                        eventName: event.target.files[0].name,
                        file: URL.createObjectURL(event.target.files[0]),
                    };
                    const upload: any = await uploads.UploadFile(newDataFiles.eventFile);
                    if (upload) {
                        setTaskSelectedWordForTranslation({ ...taskSelectedWordForTranslation, fileImg: upload.result });
                        // eslint-disable-next-line no-param-reassign
                        event.target.value = null;
                    }
                }
            };

            return (
                <>
                    <FormControl style={adjustWidthSelectedActivities}>
                        <InputLabel>Opção correta</InputLabel>
                        <Select value={taskSelectedWordForTranslation.correct} onChange={onChangeOptionCorrect}>
                            {RenderAllOptionsCorrect()}
                        </Select>
                    </FormControl>
                    <Button
                        style={adjustButtonLogo}
                        title={taskSelectedWordForTranslation?.file}
                    >
                        <Logo src={defaultSound} />
                        {taskSelectedWordForTranslation?.file ? (
                            <ContainerAdjustIconEdit right="40px" style={adjustMarginBottom}>
                                <CheckCircle color="inherit" />
                            </ContainerAdjustIconEdit>
                        ) : null}
                        <InputNullSelectedPhoto
                            accept=".mp3,audio/*"
                            onChange={SelectedAudio}
                            type="file"
                        />
                    </Button>
                    <Button
                        style={adjustButtonLogo}
                        title={taskSelectedWordForTranslation?.fileImg}
                    >
                        <Logo src={taskSelectedWordForTranslation?.fileImg || defaultPhoto} />
                        <InputNullSelectedPhoto
                            accept="image/png, image/jpeg, image/jpg"
                            onChange={SelectedPhoto}
                            type="file"
                        />
                    </Button>
                </>
            );
        }
        if (options > 0 && allOptions && skipTask) {
            return (
                <FormControl style={adjustWidthSelectedActivities}>
                    <InputLabel>Pular/Não pular</InputLabel>
                    <Select value={taskSelectedWordForTranslation.skip} onChange={onChangeOptionSkipTask}>
                        <MenuItem value="true">Pular</MenuItem>
                        <MenuItem value="false">Não pular</MenuItem>
                    </Select>
                </FormControl>
            );
        }

        return null;
    };

    const RenderInputsOptions = (label: string, value: string, onChange: any) => {
        const ValueActual = value;
        return (
            <TextField
                fullWidth
                label={`${label} (${ValueActual?.length}/200)`}
                onChange={onChange}
                style={marginDefault}
                value={value}
            />
        );
    };

    const RenderInputsTitles = (label: string, value: string, onChange: any) => {
        const ValueActual = value;
        return (
            <>
                <ContainerOptions marginTop="10px" />
                <TextField
                    fullWidth
                    label={`${label} (${ValueActual?.length}/200)`}
                    onChange={onChange}
                    value={value}
                />
            </>
        );
    };

    const RenderInputsBody = () => {
        if (taskSelectedWordForTranslation.options?.length) {
            return taskSelectedWordForTranslation.options.map((item: any, index: number) => {
                const indexFormat = index + 1;
                const indexZero = indexFormat < 10 ? 0 : '';

                const onChangeOption = (txt: any) => {
                    if (txt.target.value.length <= 200) {
                        const [getOneOption] = taskSelectedWordForTranslation.options.filter(
                            (v: any) => v.id === item.id,
                        );
                        if (getOneOption.id === item.id) {
                            const removeOneOption = taskSelectedWordForTranslation.options.filter(
                                (v: any) => v.id !== item.id,
                            );
                            const optionModified = {
                                option: txt.target.value,
                                id: getOneOption.id,
                            };
                            const newDataOption = [...removeOneOption, optionModified];
                            const orderNewDataOption = newDataOption.sort((a, b) => {
                                if (a.id < b.id) return -1;
                                if (a.id > b.id) return 1;
                                return 0;
                            });
                            setTaskSelectedWordForTranslation({
                                ...taskSelectedWordForTranslation,
                                options: orderNewDataOption,
                            });
                        }
                    }
                };

                return (
                    <ContainerOptions marginTop="10px" style={{ width: '49%' }}>
                        {RenderInputsOptions(`Opção ${indexZero}${indexFormat}`, item.option, onChangeOption)}
                    </ContainerOptions>
                );
            });
        }

        return null;
    };

    const RenderAllItems = () => {
        if (allMenuItems.ids.length) {
            return allMenuItems.ids.slice(0, 4).map((idSelected: any) => (
                <MenuItem value={idSelected}>{idSelected}</MenuItem>
            ));
        }
        return null;
    };

    const EndIcon = () => (
        <Send />
    );

    const RenderIconGoBack = () => (
        <NavigateBefore />
    );

    return (
        <>
            <ContainerOptions>
                <TitleOption width="100%">Criação da Atividade - Escolha a palavra/expressão que corresponde a sua tradução</TitleOption>
            </ContainerOptions>
            {RenderInputsTitles('Título da atividade', taskSelectedWordForTranslation.title, onChangeTitle)}
            {RenderInputsTitles('Subtítulo da atividade', taskSelectedWordForTranslation.subtitle, onChangeSubtitle)}
            {RenderInputsTitles('Pergunta da atividade', taskSelectedWordForTranslation.question, onChangeQuestion)}
            <FormControl style={adjustWidthSelectedActivities}>
                <InputLabel>Quantidade</InputLabel>
                <Select value={taskSelectedWordForTranslation.target} onChange={onChangeTarget}>
                    {RenderAllItems()}
                </Select>
            </FormControl>
            <ContainerOptions marginTop="10px">
                {RenderInputsBody()}
            </ContainerOptions>
            <ContainerOptions marginTop="10px" width="100%">
                {RenderSelectedCorrectOptions(false)}
                {RenderSelectedCorrectOptions(true)}
            </ContainerOptions>
            <ContainerOptions marginTop="40px">
                <Button
                    color="primary"
                    startIcon={RenderIconGoBack()}
                    onClick={BackScreenModal}
                    variant="contained"
                >
                    Voltar
                </Button>
                <Button
                    color={validationBackground()}
                    disabled={validationDisabled()}
                    endIcon={EndIcon()}
                    onClick={CreateTask}
                    variant="contained"
                >
                    {taskSelectedWordForTranslation?.id ? 'Editar Atividade' : 'Criar Atividade'}
                </Button>
            </ContainerOptions>
        </>
    );
};

export default TaskSelectedWordForTranslation;
